import { MitarbeiterSpeicheroptionenDialog } from '@/domain/mitarbeiter/features/anlageassistent/components/MitarbeiterSpeicheroptionen/MitarbeiterSpeicheroptionenDialog';
import { MitarbeiterSpeicheroptionenDrawer } from '@/domain/mitarbeiter/features/anlageassistent/components/MitarbeiterSpeicheroptionen/MitarbeiterSpeicheroptionenDrawer';
import { useAnlageassistentContext } from '@/domain/mitarbeiter/features/anlageassistent/context/useAnlageassistentContext';
import { Button } from '@e2n/ui/v2';
import { useTranslation } from 'react-i18next';

export function DesktopFooter() {
  const { t } = useTranslation();
  const { ctx } = useAnlageassistentContext();

  return (
    <div className="px-8 py-4 bg-neutrals-100 border-t border-neutrals-300 flex sticky bottom-0">
      {ctx.hasPrevious() && (
        <Button
          variant="secondary-blue"
          onClick={() => {
            ctx.previous();
          }}>
          {t('domain.mitarbeiter.create.navigationZurueck')}
        </Button>
      )}
      {ctx.hasNext() && (
        <Button
          className="ml-auto"
          onClick={() => {
            ctx.next();
          }}>
          {t('domain.mitarbeiter.create.navigationWeiter')}
        </Button>
      )}
      {ctx.state.steps[ctx.state.currentStepIndex].type === 'summary' && (
        <MitarbeiterSpeicheroptionenDialog />
      )}
    </div>
  );
}

export function MobileFooter() {
  const { t } = useTranslation();
  const { ctx } = useAnlageassistentContext();

  return (
    <div className="sticky bottom-0 p-4 border-t border-neutrals-300 bg-neutrals-100 mt-auto">
      {ctx.hasNext() ? (
        <Button className="w-full" onClick={() => ctx.next()}>
          {t('domain.mitarbeiter.create.navigationWeiter')}
        </Button>
      ) : (
        <MitarbeiterSpeicheroptionenDrawer />
      )}
    </div>
  );
}
